import {Component, OnInit} from '@angular/core';
import {LocalStorageService} from './services/local-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'Alef School';
  private roles: string[];
  isLoggedIn = false;
  showAdminBoard = false;
  showModeratorBoard = false;
  tokens: number;

  constructor(private localStorageService: LocalStorageService) { }

  ngOnInit(): void {
    this.isLoggedIn = !!this.localStorageService.getToken();

    if (this.isLoggedIn) {
      const user = this.localStorageService.getUser();
      this.roles = user.roles;

      this.showAdminBoard = this.roles.includes('ROLE_ADMIN');
      this.showModeratorBoard = this.roles.includes('ROLE_MODERATOR');

      this.tokens = user.tokens;
    }
  }
}
